var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page"},[_c('el-container',[_c('el-header',{staticStyle:{"margin":"0","padding":"0"}},[_c('headerMenu')],1),_c('el-main',{staticStyle:{"margin":"0","padding":"0"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }